<div *ngIf="pid" name="form_new_file" class="new-file-component">
  <div *ngIf="working" class="working-background">
    <mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>
  </div>

  <form class="full-width-form">
    <h1 *ngIf="!newFile._id">{{translate.instant('VOEG EEN DOCUMENT TOE')}}</h1>
    <h1 *ngIf="newFile._id && fileIsEditable()">{{translate.instant('BEWERK HET DOCUMENT')}}</h1>
    <h1 *ngIf="newFile._id && !fileIsEditable()">{{translate.instant('BEWERK HET BESTAND')}}</h1>

    <mat-grid-list *ngIf="fileIsEditable()" cols="6" rowHeight="55px" gutterSize="15px">
      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.NAME')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">
        <mat-form-field>
          <mat-label></mat-label>
          <input matInput name="name" type="text" [(ngModel)]="newFile.name"
            [placeholder]="translate.instant('DATA.NAME')" class="full-width margin-right-md">
          <mat-hint>{{translate.instant('NEW_FILE.HINT.NAME')}}</mat-hint>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.DESCRIPTION')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">
        <mat-form-field>
          <mat-label></mat-label>
          <input matInput name="description" type="text" [(ngModel)]="newFile.description"
            placeholder="{{translate.instant('DATA.DESCRIPTION')}}" class="full-width margin-right-md">
          <mat-hint>{{translate.instant('NEW_FILE.HINT.DESCRIPTION')}}</mat-hint>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.TYPE')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">
        <mat-form-field>
          <mat-label></mat-label>
          <input matInput name="type" type="text" [matAutocomplete]="typeAutocomplete"
            placeholder="{{translate.instant('DATA.TYPE')}}" class="full-width margin-right-md"
            [formControl]="fileTypeControl" [(ngModel)]="newFile.type">
          <mat-hint>{{translate.instant('NEW_FILE.HINT.TYPE')}}</mat-hint>
          <mat-autocomplete #typeAutocomplete="matAutocomplete">
            <mat-option *ngFor="let fileType of filteredFileTypes | async" [value]="fileType.value">
              {{ fileType.value }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile class="first" [colspan]="1">
        <label>{{translate.instant('DATA.JOB')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">

        <mat-form-field>
          <mat-label></mat-label>
          <input matInput name="job" type="text" [matAutocomplete]="jobAutocomplete"
            placeholder="{{translate.instant('DATA.JOB')}}" class="full-width margin-right-md"
            [formControl]="jobControl" [(ngModel)]="newFile.job">
          <mat-hint>{{translate.instant('NEW_FILE.HINT.JOB')}}</mat-hint>
          <mat-autocomplete #jobAutocomplete="matAutocomplete">
            <mat-option *ngFor="let job of filteredJobs | async" [value]="job.value">
              {{ job.value }}
            </mat-option>
          </mat-autocomplete>

        </mat-form-field>

      </mat-grid-tile>


      <mat-grid-tile class="first">
        <label>{{translate.instant('DATA.ROOM')}}:</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">
        <mat-label></mat-label>
        <select name="room" [(ngModel)]="newFile.room" class="full-width margin-right-md room"
          [hidden]="pid.rooms.length == 0">
          <option *ngFor="let r of pid.rooms" [value]="r">{{r}}</option>
          <option value="" selected>{{translate.instant('DATA.NEW_ROOM')}}</option>
        </select>
        <mat-form-field *ngIf="newFile.room == ''">
          <mat-label></mat-label>
          <input matInput name="newRoom" type="text" [(ngModel)]="newRoom"
            placeholder="{{translate.instant('DATA.ROOM')}}" class="full-width">
          <mat-hint>{{translate.instant('NEW_FILE.HINT.ROOM')}}</mat-hint>
        </mat-form-field>

      </mat-grid-tile>

      <div *ngFor="let n of notifications; let index=index; trackBy:indexTracker ">

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="1">
          <label>{{translate.instant('DATA.NOTIFICATIONS')}} {{index+1}}:</label>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="3">
          <mat-form-field>
            <input matInput [(ngModel)]="n.topic" [ngModelOptions]="{standalone: true}" type="text"
              placeholder="{{translate.instant('DATA.TOPIC')}}" class="full-width margin-right-md">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="1">
          <mat-form-field>
            <input matInput [(ngModel)]="n.targetdate" [ngModelOptions]="{standalone: true}" type="date"
              placeholder="{{translate.instant('DATA.TARGET_DATE')}}"
              (change)="targetdateChangeEvent($event.target.value, index)" class="full-width margin-right-md">
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="notrowspan" [colspan]="1">
          <select [(ngModel)]="n.frequency" class="frequency" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let f of frequencies" [value]="f">{{translate.instant('DATA.' + f)}}</option>
          </select>
        </mat-grid-tile>

        <!--<input matInput [(ngModel)]="n.frequency" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{translate.instant('DATA.FREQUENCY')}}"
                   class="full-width margin-right-md">-->

      </div>


      <mat-grid-tile [rowspan]="notrowspan" [colspan]="1">
        <label *ngIf="!notifications.length">{{translate.instant('DATA.NOTIFICATIONS')}}</label>
      </mat-grid-tile>

      <mat-grid-tile [rowspan]="notrowspan" [colspan]="2">
        <div class="addNotification">
          <a (click)="addNotification()" class="link">
            <i class="material-icons">add</i>{{translate.instant('DATA.ADD_NOTIFICATION')}}
          </a>
        </div>
      </mat-grid-tile>

      <mat-grid-tile [rowspan]="notrowspan" [colspan]="3">
        <mat-hint align="end">{{translate.instant('DATA.DEL_NOTIFICATION')}}</mat-hint>
      </mat-grid-tile>

    </mat-grid-list>

    <h1 class="mboth"></h1>

    <mat-grid-list *ngIf="fileIsEditable()" cols="6" rowHeight="55px" gutterSize="15px">

      <mat-grid-tile class="first">
        <label>{{translate.instant('DATA.CONTRACTOR')}} </label>
      </mat-grid-tile>

      <mat-grid-tile class="second" [colspan]="5">
        <div class="wrapper-select full-width margin-right-md">

          <mat-form-field>
            <mat-label></mat-label>
            <input matInput name="contractor" type="text" [matAutocomplete]="contractorAutocomplete"
              placeholder="{{translate.instant('DATA.CONTRACTOR')}}" class="full-width margin-right-md"
              [formControl]="contractorControl" [(ngModel)]="newFile.contractor">

            <mat-hint>{{translate.instant('NEW_FILE.HINT.CONTRACTOR')}}</mat-hint>

            <mat-autocomplete #contractorAutocomplete="matAutocomplete">
              <mat-option *ngFor="let c of filteredContractors | async" [value]="c.name + ' (' + c.email + ')'">
                {{ c.name }} ({{c.email}})
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

        </div>
      </mat-grid-tile>

      <mat-grid-tile class="first" *ngIf="!newFile.contractor.length">
        <label>{{translate.instant('DATA.NAME')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" *ngIf="!newFile.contractor.length" [colspan]="5">
        <mat-form-field>
          <input matInput name="newContractorName" type="text" [(ngModel)]="newContractor.name"
            class="full-width margin-right-md">
          <mat-hint class="red" *ngIf="!newContractor.name">{{translate.instant('MESSAGE.IS_REQUIRED', {data:
            translate.instant('DATA.NAME')})}}
          </mat-hint>
        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile class="first" class="first" *ngIf="!newFile.contractor.length">
        <label>{{translate.instant('DATA.EMAIL')}} *</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" *ngIf="!newFile.contractor.length" [colspan]="5">
        <mat-form-field>
          <input matInput name="newContractorEmail" type="email" [(ngModel)]="newContractor.email"
            class="full-width margin-right-md">

        </mat-form-field>
      </mat-grid-tile>


      <mat-grid-tile class="first" *ngIf="!newFile.contractor.length">
        <label *ngIf="!newFile.contractor.length">{{translate.instant('DATA.PHONE')}}</label>
      </mat-grid-tile>

      <mat-grid-tile class="second" *ngIf="!newFile.contractor.length" [colspan]="5">
        <mat-form-field>
          <input matInput name="newContractorPhone" type="text" [(ngModel)]="newContractor.phone"
            class="full-width margin-right-md">
        </mat-form-field>
      </mat-grid-tile>


    </mat-grid-list>

    <mat-grid-list *ngIf="newFile.contractor.length" cols="6" rowHeight="{{getContractorRowHeight(1)}}"
      gutterSize="25px">

      <mat-grid-tile></mat-grid-tile>

      <mat-grid-tile [colspan]="5">
        <div class="contact-info-wrapper">
          <div>{{translate.instant('DATA.NAME')}}: {{getContractorInfo().name}}</div>
          <div>{{translate.instant('DATA.EMAIL')}}: {{getContractorInfo().email}}</div>
          <div *ngIf="getContractorInfo().phone">{{translate.instant('DATA.PHONE')}}: {{getContractorInfo().phone}}
          </div>
        </div>
      </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="6" rowHeight="{{getContractorRowHeight(2)}}" gutterSize="15px">

      <mat-grid-tile></mat-grid-tile>

      <!--<label class="select-label">{{translate.instant('DATA.FILE')}}:</label>-->
      <mat-grid-tile [colspan]="5">
        <mat-radio-group name="customFile" [(ngModel)]="newFile.providedByContractor" (change)="updateFileUploadSpan()">
          <mat-radio-button [value]="true" class="margin-right-md">
            {{translate.instant('NEW_FILE.SEND_MAIL_RADIO')}}
          </mat-radio-button>
          <mat-radio-button [value]="false">{{translate.instant('PID.HAVE_FILE')}}</mat-radio-button>
        </mat-radio-group>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="6" rowHeight="45px" gutterSize="15px">

      <mat-grid-tile></mat-grid-tile>

      <mat-grid-tile [colspan]="5" [rowspan]="fileUploadRowSpan">
        <div *ngIf="!newFile.providedByContractor && (newFile.sharingType != 'distinct' || !this.fileIsEditable())"
          style="width:100%">

          <!--<div *ngFor="let upload of filesToUpload; let i=index">
            <input name="upload_{{i}}" [(ngModel)]="filesToUpload[i].upload" type="checkbox">{{upload.file.name}}
          </div>-->
          <div style="float:left; width:50%;" [style.height]="uploadZoneHeight()">
            <div style="width:90%">
              <div style="margin-bottom:15px;margin-top:-5px">
                <button type="button" style="width:100%;text-align: left;" 
                  (drop)="fileDropEvent($event)"
                  class="dragarea" 
                  (dragend)="dragend($event)" (dragleave)="dragend($event)"
                  (dragover)="dragover($event)" (dragenter)="dragover($event)"
                  [style.height]="(newFile.version && newFile.version.length) ? '51px' : '41px'" mat-stroked-button
                  (click)="fileInput.click()">
                  {{translate.instant('CONTRACTOR_UPLOAD.ADD_NEW')}}
                </button>

                <input hidden type='file' #fileInput name='file' id='file' accept={{acceptedFileMIMETYPE}}
                  (change)="fileChangeEvent($event)" multiple />
              </div>

              <mat-form-field *ngIf="filesToUpload.length" appearance="outline">
                <mat-label>{{translate.instant('CONTRACTOR_UPLOAD.SELECT')}}</mat-label>
                <mat-select #uploadselect name="upload" [(ngModel)]="upload" multiple>
                  <mat-option (click)="selectAllReUpload(1)">{{translate.instant('CONTRACTOR_UPLOAD.SELECT_ALL')}}
                  </mat-option>
                  <mat-option (click)="selectNoneReUpload(1)">{{translate.instant('CONTRACTOR_UPLOAD.SELECT_NONE')}}
                  </mat-option>
                  <mat-option *ngFor="let upload of filesToUpload; let i=index" [value]="i">{{upload.file.name}}
                  </mat-option>
                </mat-select>
                <br />

              </mat-form-field>
            </div>
            <div style="width:10%"></div>
          </div>

          <div style="float:left; width:50%" [style.height]="uploadZoneHeight()">

            <div style="width:90%" *ngIf="newFile.version && newFile.version.length">
              <!--<div *ngFor="let upload of latestFiles(); let i=index">
                <input value="{{upload._id}}" name="reupload_{{i}}" [(ngModel)]="reupload[i]" type="checkbox">{{upload.name}}
              </div>-->
              <mat-form-field appearance="outline" style="margin-top:-5px">
                <!--class="file-multi-select"-->
                <mat-label>{{translate.instant('CONTRACTOR_UPLOAD.SELECT_FROM_PREVIOUS')}}</mat-label>

                <mat-select #reuploadselect name="reupload" [(ngModel)]="reupload" multiple>
                  <mat-option (click)="selectAllReUpload(0)">{{translate.instant('CONTRACTOR_UPLOAD.SELECT_ALL')}}
                  </mat-option>
                  <mat-option (click)="selectNoneReUpload(0)">{{translate.instant('CONTRACTOR_UPLOAD.SELECT_NONE')}}
                  </mat-option>
                  <mat-option *ngFor="let upload of latestFiles(); let i=index" [value]="upload._id">{{upload.name}}
                  </mat-option>
                </mat-select>
                <br />

              </mat-form-field>

              <!--{{reupload}}-->
            </div>
            <div style="width:10%"></div>
          </div>
          <hr />

          <div class="alert-warning" *ngIf="newFile.version && newFile.version.length">
            <i class="material-icons ic-warning">warning</i> {{translate.instant('CONTRACTOR_UPLOAD.OVERWRITE')}}
          </div>

        </div>

        <div *ngIf="newFile.providedByContractor">
          <div class="wrapper-select full-width margin-right-md margin-bottom-lg">
            <label class="select-label">{{translate.instant('DATA.DEADLINE')}}:</label>
            <br />
            <input matInput name="completion" type="date" [(ngModel)]="newFile.completion" placeholder=""
              (blur)="debug($event)" class="full-width margin-right-md mat-input-style" [value]="newFile.completion" />
          </div>

          <div *ngIf="newFile.emailSent" class="alert-warning margin-bottom-sm margin-right-md">
            <i class="material-icons ic-warning">warning</i> {{translate.instant('NEW_FILE.SEND_NEW_MAIL')}}
          </div>

          <div class="alert-info margin-right-md">
            <i class="material-icons ic-info">info</i>&nbsp;{{translate.instant('MESSAGE.WARNING_SENDING_EMAIL')}}
          </div>
        </div>

      </mat-grid-tile>

    </mat-grid-list>


    <!-- Sub-PID sharing -->
    <div *ngIf="pid && pid.children && pid.children.display && pid.children.display.length && fileIsEditable()">
      <br />
      <br />

      <label class="select-label">{{translate.instant('PID.SUBPID_SHARING')}}</label>
      <br />

      <label class="select-label">{{translate.instant('PID.SHARING_TYPE')}}</label>
      <select name="sharingType" [(ngModel)]="newFile.sharingType">
        <option value="shared">
          {{translate.instant('PID.SHARING_SHARED')}}
        </option>
        <option value="distinct">
          {{translate.instant('PID.SHARING_DISTINCT')}}
        </option>
      </select>

      <br />
      <br />

      <label class="select-label">{{translate.instant('PID.UNITS')}}:</label>
      <br />

      <div style="padding-left:15px;">
        <mat-checkbox name="shared_by_all" [(ngModel)]="sharing.all" (change)="selectAll()">
          <span class="margin-left-md">{{translate.instant('PID.SELECT_ALL')}}</span>
        </mat-checkbox>
      </div>
      <br />
      <div *ngFor="let subPid of subPidSharing" style="padding-left:15px;">
        <mat-checkbox name="shared_by_{{subPid.id}}" [(ngModel)]="subPid.sharedWith">
          <div class="margin-left-md" style="min-width:300px;margin-right: 40px; display:inline-block">{{subPid.name}}
          </div>
        </mat-checkbox>
        <span *ngIf="subPid.version"><a (click)="goToSubPid(subPid.id)">{{translate.instant('PID.SUBPID_FILE_VIEW')}}
            {{subPid.version | date: 'dd/MM/yyyy'}}</a></span>
      </div>

    </div>
  </form>

</div>